// extracted by mini-css-extract-plugin
export default {"divider":"g__divider--KapZH","content":"g__content--YY83U","title":"g__title--_B5Gg"};